import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Row, Col } from '@zendeskgarden/react-grid';
const {
  media_md
} = variables;

export const ItemCol = styled(Col)`
  padding: 0px 10px;
  margin-bottom: 40px;
  @media ${media_md} {
    margin-bottom: 80px;
    padding: 0px 50px;
  }
  &:last-child {
    margin-bottom: 100px;
  }
`

export const ItemRow = styled(Row)`
  margin-top: 50px;
  @media ${media_md} {
    margin-top: 0px;
  }
`

